import Image from "next/image"
import Link from "next/link"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import Linked from "public/assets/linkedin-blue.svg"

export default function AdvisoryBoard({ advisors }) {
  return (
    <section className="bg-gray-gradient">
      <div className="mx-auto max-w-screen-xl px-5 py-10 lg:py-14">
        <h2 className="text-center pb-8 lg:pb-12">Meet Our Advisory Board</h2>
        <div className="flex flex-wrap gap-y-4 lg:gap-y-8 justify-center">
          {advisors?.map((adv, idx) => (
            <div className="text-center basis-1/2 lg:basis-1/4 px-2" key={idx}>
              <Image
                src={adv.content.image.filename}
                alt={adv.content.image.alt}
                height="200"
                width="200"
                className="rounded-full mx-auto"
              />
              <div className="flex flex-col items-center gap-3 pt-4">
                <h3>{adv.content.name}</h3>
                <div className="font-black">{adv.content.title}</div>
                <div>{adv.content.organization}</div>
                {adv.content.linkedin_link.url !== "" && (
                  <Link href={getStoryblokLink(adv.content.linkedin_link)} target="_blank">
                    <Linked className="text-primary hover:text-secondary transition-all duration-300" />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
